import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CountryGateway } from 'src/app/application/gateway/CountryGateway';
import { ConsigneeNotifierAdminService } from 'src/app/application/service/ConsigneeNotifierAdminService';
import {
  ConsigneeNotifierAdmin,
  ConsigneeNotifierAdminAssignUserRequest,
} from 'src/app/domain/models/ConsigneeNotifierAdmin';
import { Country } from 'src/app/domain/models/Country';
import { ProfileUtils } from 'src/app/ui/util/profile-utils';

@Component({
  selector: 'app-admin-assign-consignee-notifier-user',
  templateUrl: './admin-assign-consignee-notifier-user.component.html',
  styleUrls: ['./admin-assign-consignee-notifier-user.component.css'],
})
export class AdminAssignConsigneeNotifierUserComponent {
  @Input() profileId: number | undefined;
  @Output() closeDialog = new EventEmitter();

  countries: Country[] = [];
  selectedCountry: number | undefined;
  selectedType: string = 'consignee';
  consigneesNotifiers: ConsigneeNotifierAdmin[] = [];
  types = [
    { label: 'Consignee', value: 'consignee' },
    { label: 'Notifier', value: 'Notifier' },
  ];

  constructor(
    private readonly _messageService: MessageService,
    private readonly _consigneeNotifierAdminService: ConsigneeNotifierAdminService,
    private readonly _countryService: CountryGateway,
    private readonly _confirmationService: ConfirmationService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    if (this.profileId) {
      this.loadCountries();
    }
  }

  loadConsigneesNotifiers(): void {
    if (this.selectedCountry && this.selectedType) {
      this._consigneeNotifierAdminService
        .getAllByCountryIdAndType(this.selectedCountry, this.selectedType)
        .subscribe({
          next: (v) => {
            this.consigneesNotifiers = v;
          },
          error: (e) => {
            this._messageService.add({
              severity: 'error',
              summary: 'Acción fallida',
              detail: 'No se pudo recuperar los consignees y notifiers.',
            });
          },
        });
    }
  }

  loadCountries(): void {
    this._countryService.getAll().subscribe({
      next: (v) => {
        this.countries = v.sort((a, b) => a.id - b.id);
        if (this.countries.length > 0) {
          this.selectedCountry = this.countries[0].id;

          if (this.selectedType) {
            this.loadConsigneesNotifiers();
          }
        }
      },
      error: (e) => {
        this._messageService.add({
          severity: 'error',
          summary: 'Acción fallida',
          detail: 'No se pudo recuperar la lista de paises.',
        });
      },
    });
  }

  filter(): void {
    if (this.selectedCountry && this.selectedType) {
      this.loadConsigneesNotifiers();
    }
  }

  assignConsigneeNotifier(consigneNotifier: any): void {
    this._confirmationService.confirm({
      message: this.translate.instant(
        'MessageService.ConsigneeNotifier.ConfirmAssignDialogMessage',
        {type: consigneNotifier.type[0].toUpperCase() + consigneNotifier.type.substring(1), name: consigneNotifier.contactName}
      ),
      header: this.translate.instant(
        'MessageService.ConsigneeNotifier.ConfirmAssignDialogHeader' , {type: consigneNotifier.type[0].toUpperCase() + consigneNotifier.type.substring(1)}
      ),
      icon: 'pi pi-users',
      acceptLabel: this.translate.instant(
        'MessageService.ConsigneeNotifier.AssignButton'
      ),
      rejectLabel: this.translate.instant(
        'MessageService.ConsigneeNotifier.CancelButton'
      ),
      acceptIcon: 'pi',
      rejectIcon: 'pi',
      accept: () => {
        if (this.profileId) {
          let request: ConsigneeNotifierAdminAssignUserRequest = {
            userId: this.profileId,
            consigneNotifierAdminId: consigneNotifier.id,
          };

          this._consigneeNotifierAdminService.assignUser(request).subscribe({
            next: (v) => {
              this._messageService.add({
                severity: 'info',
                summary: this.translate.instant(
                  'MessageService.Summary.SuccessAction'
                ),
                detail: this.translate.instant(
                  'MessageService.ConsigneeNotifier.AssignSuccess', {type: consigneNotifier.type[0].toUpperCase() + consigneNotifier.type.substring(1)}
                ),
              });
            },
            error: (e) => {
              this._messageService.add({
                severity: 'error',
                summary: this.translate.instant(
                  'MessageService.Summary.FailedAction'
                ),
                detail: this.translate.instant(
                  'MessageService.ConsigneeNotifier.AssignError', {type: consigneNotifier.type[0].toUpperCase() + consigneNotifier.type.substring(1)}
                ),
              });
            },
          });
        }
      },

      reject: (type: any) => {
        switch (type) {
        }
      },
    });
  }

  close(): void {
    this.closeDialog.emit();
  }
}
